/*
 * 薪酬报表
 *
 * *
 * */
import { ticketClient } from "@/api/ticketClient";
import {
  ReduceTicketReq
} from "@/pbjs/external/ticket/ticket_pb";
import { ApplyReducePenaltyFieldDetail } from "@/pbjs/xcommon/core_pb";
import { Page } from "@/utils/index";
import { setPage } from "@/utils/request";
import InnerRequest from "./request";
export interface Options {
  itemid: number;
  id: number;
  orderid:string;
  appname:string;
}
export function setReduceTicketReq(arg: Options) {
  let request: any = new ReduceTicketReq();
  request.setItemid(arg.itemid);
  request.setTicketid(arg.id);
  request.setOrderid(arg.orderid);
  request.setAppname(arg.appname);

  console.log("ReduceTicketReq", arg, request);
  return request;
}
export const reduceTicketRequest = new InnerRequest(
  ticketClient,
  ticketClient.reduceTicket
);
